export enum stringRuleBool {
  TRUE = 'True',
  FALSE = 'False'
}
